import { Resizable } from 're-resizable';
import React, { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import DateIcon from '../../../assets/icons/date.svg';
import { FileContext } from '../../../context/FileContext';
import { useColumnOrder } from '../../../hooks/useColumnOrder';
import { isSignerEligibleColumn } from '../../../utils/signer-column-eligibility';

export const SIGN_DATE_WITH_EMAIL_DEFAULT_HEIGHT = 26.66;
export const SIGN_DATE_WITH_EMAIL_DEFAULT_WIDTH = 183.33;


const SignDateWithEmailAssignEditChip = ({ item, setIsResizing }) => {

  const defaultFontSize = 11;
  const { rgbMapper } = useColumnOrder();
  const noPadding = item.noPadding || false;
  const itemColor = item.color ?? item.signer?.color;
  const backgroundColor = itemColor
    ? rgbMapper[itemColor] ?? itemColor
    : '#E6E6FA';

  const {
    addedFormFields,
    updateFormFields,
    currentSelectedItem,
    boardData,
    draggableFieldsData,
  } = useContext(FileContext);
  const { t } = useTranslation();

  const handleResizeStart = (_e, _dir) => {
    setIsResizing(true);
  };

  const handleResizeEnd = (item) => (_e, _dir, _ref, d) => {
    setIsResizing(false);

    item.width = _ref.clientWidth;
    item.height = _ref.clientHeight;

    addedFormFields[currentSelectedItem.current] = item;

    draggableFieldsData[item.itemId] = {
      height: item.height,
      width: item.width,
    };
    updateFormFields([...addedFormFields]);
  };

  // handle email label if changed from monday board
  const emailColumns = boardData?.columns?.filter((col) =>
    isSignerEligibleColumn(col),
  );
  const getTitle = useCallback(
    (id) => {
      if (!emailColumns) return;
      const title = emailColumns?.find((x) => x.id === id)?.title || '';
      return title;
    },
    [emailColumns],
  );

  const label = useMemo(() => {
    if (item?.signer?.label) {
      return item.signer.label === 'Me'
        ? item.signer.label
        : getTitle(item.signer.emailColumnId);
    }

    return t('Sign Date');
  }, [item, t, getTitle]);

  return (
    <div
      className={clsx(
        'text-[11px] font-normal rounded border-4',
        item.isActive
          ? 'border-[rgba(0,115,234,0.4)]'
          : 'border-transparent hover:border-[rgba(0,115,234,0.4)]'
      )}
      style={{
        padding: noPadding ? '0' : '2px',
      }}
    >
      <Resizable
        size={{
          height:  SIGN_DATE_WITH_EMAIL_DEFAULT_HEIGHT,
          width:  SIGN_DATE_WITH_EMAIL_DEFAULT_WIDTH,
        }}
        lockAspectRatio={false}
        enable={{
          top: false,
          right: item?.isActive,
          bottom: item?.isActive,
          left: false,
          topRight: false,
          bottomRight: item?.isActive,
          bottomLeft: false,
          topLeft: false,
        }}
        className={item.isActive ? 'resizeable' : ''}
        onResizeStart={handleResizeStart}
        onResizeStop={handleResizeEnd(item)}
      >
      <div className="flex items-center w-full h-full rounded text-black" style={{
            fontSize: `${defaultFontSize}px`,
            lineHeight: '1.4',
            paddingLeft: noPadding ? '0' : '8px',
            paddingRight: noPadding ? '0' : '8px',
            border: '1px solid #c5c7d0',
            backgroundColor: backgroundColor,
            borderRadius: '4px',
            width: '100%',
            height: '100%',
          }}>
          <div>
            <img
              src={DateIcon}
              alt=""
              height={16}
              width={16}
              className={clsx(noPadding ? 'mr-0' : 'mr-[10px]')}
              style={{ transform: 'translateY(4px)' }}
            />
            {label}
          </div>
      </div>

      </Resizable>
    </div>
  );
};

export default SignDateWithEmailAssignEditChip;
